import React, { ChangeEvent, useEffect, useState } from "react";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";

import { ErrorMessage, MainImageBackground, Separator } from "src/components";
import styles from "./styles.module.scss";
import { UIButton, UICard, UIText } from "src/components/uIKit";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import {
  API_RESULT,
  CHANNELS,
  INPUT_LENGTH,
  LOGIN_STEP,
  ROUTES,
  TEXT_TAGS,
  URL_SOURCE_TYPE,
} from "src/utils/enums";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  COOLDOWN_PERIOD,
  pcPlusRoutes,

} from "src/utils/consts";
import {
  __DEV__,
  getChannelId,
  handleResponseCode,
  logPfsAnalyticsEvent,
} from "src/utils/utils";
import { checkFXEligibility } from "src/redux/slices/appSlice/AppApi";
import { useIsDigitalOrDigitalAgent } from "src/hooks/useIsDigitalOrDigitalAgent";

import {
  checkOrCreateOtp,
  updatePolicy,
} from "src/redux/slices/userSlice/UserApi";
import {
  CheckFxEligibilityRequest,
  UpdatePolicyRequest,
  PolicyDetailsUpdate,
  UpdateOnboardingAnalytics,
} from "src/utils/types";
import {
  resetFXEligibilityStatus,
  setCampaignId,
  setCampaignName,
  setTravelPolicyNumber,
} from "src/redux/slices/appSlice/AppSlice";
import { resetCheckOrCreateOtpResStatus } from "src/redux/slices/userSlice/UserSlice";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
import { useRouteParams } from "src/hooks/useRouteParams";

type Title = { text: string; ariaLabel: string };
type ErrorText = { text: string; ariaLabel: string };
const LoginScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentSource, prefixChild, currentPath } = useRouteParams();
  const { LOGIN_PATHS } = useRouteParams();
  const [operationModel, setOperationModel] = useState<number>(1);
  const {
    strings,
    hostUrl,
    fXEligibilityResStatus,
    fXEligibilityData,
    businessUnit,
    otpErrorMessage,
    selectedPolicy,
    agentId,
    fXEligibilityErrorData,
  } = useAppSelector((state) => state.app);
  const {
    checkOrCreateOtpResStatus,
    checkOrCreateOtpRes,
    updatePolicyResStatus,
    updatePolicyRes,
    checkOrCreateOtpErrorRes,
  } = useAppSelector((state) => state.user);

  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedPolicy, setIsCheckedPolicy] = useState(false);
  const [selectedPolicyItem, setSelectedPolicyItem] = useState<number | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<ErrorText | string>("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [sendAgainDisabled, setSendAgainDisabled] = useState(false);
  const [sendAgainClicked, setSendAgainClicked] = useState(false);
  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const [sendAgainLoading, setSendAgainLoading] = useState(false);
  // const currentPath = location.pathname;
  // const currentSource = location.pathname.split("/")[1];

  // const child = location.pathname.split("/")[3];
  // const step = location.pathname.split("/")[2]?.toLowerCase();

  // const prefix = `/${currentSource}/${step}/`.toLowerCase();

  // const prefixChild = `${prefix}${child}`.toLowerCase();


  const businessUnitParam = new URLSearchParams(window.location.search).get(
    "businessUnit"
  );
  const userParam = new URLSearchParams(window.location.search).get(
    "user"
  );
  const campaignId = new URLSearchParams(window.location.search).get(
    "campaignId"
  );
  const campaignName = new URLSearchParams(window.location.search).get(
    "campaignName"
  );

  type FormData = {
    id: string;
    phone: string;
    otp: string;
  };
  const methods = useForm<FormData>({
    mode: "onSubmit", // This ensures validation only occurs on submit
    defaultValues: {
      id: "",
      phone: "",
      otp: "",
    },
  });
  const isDigitalOrAgent = useIsDigitalOrDigitalAgent();

  useEffect(() => {
    // console.log("fXEligibilityData", fXEligibilityData);
    switch (fXEligibilityResStatus) {
      case API_RESULT.SUCCEEDED:
        setShowButtonLoader(false);
        const isCuccess = fXEligibilityData.responseCode === 0;
        if (isCuccess) {
          navigate(LOGIN_PATHS.LOGIN_OTP);
        } else {
          if (fXEligibilityData.responseCode === -1) {
            setShowButtonLoader(false);
            setErrorMessage({
              text: strings.t_otp_one_or_more_wrong_fields,
              ariaLabel: strings.t_otp_one_or_more_wrong_fields,
            });
          } else {
            handleResponseCode(
              fXEligibilityData,
              currentSource,
              hostUrl,
              isDigitalOrAgent,
              strings
            );
          }
        }
        dispatch(resetFXEligibilityStatus());
        break;
      case API_RESULT.FAILED:
        setShowButtonLoader(false);
        __DEV__ && console.log("fXEligibilityErrorData == > ", fXEligibilityErrorData);
        const resStatus = fXEligibilityErrorData.status;
        const responseCode =
          fXEligibilityErrorData?.data?.responseData?.responseCode;

        if (resStatus == 500 || responseCode == -1) {
          const errText = strings.somethingWentWrong;
          setErrorMessage({
            text: errText,
            ariaLabel: errText,
          });
          return;
        }

        handleResponseCode(
          fXEligibilityErrorData?.data?.responseData,
          currentSource,
          hostUrl,
          isDigitalOrAgent,
          strings
        );
        dispatch(resetFXEligibilityStatus());
        break;
      default:
        // setShowButtonLoader(false);
        break;
    }
  }, [fXEligibilityResStatus]);

  const loginRequest = (data: FormData) => {
    const areaCode = data.phone.slice(0, 3);
    const phone = data.phone.slice(3);
    setShowButtonLoader(true);
    // get businessUnit param from url

    // const currentSource = location.pathname.split("/")[1]?.toLocaleLowerCase();
    const channel = getChannelId(hostUrl);
    const dataReq: CheckFxEligibilityRequest = {
      personalId: data.id,
      areaCode,
      phone,
      channel: channel,
      countryPhoneCode: "972",
      businessUnit: businessUnitParam,
      feCampaignId: channel === CHANNELS.CAMPAIGN ? campaignId : null,
      feCampaignName: channel === CHANNELS.CAMPAIGN ? campaignName : null,
      userId: userParam,

    };
    dispatch(setCampaignId(campaignId || null));
    dispatch(setCampaignName(campaignName || null));

    dispatch(checkFXEligibility(dataReq));
  };
  const onSubmit: SubmitHandler<FormData> = (data) => {
    setSendAgainClicked(false);
    setErrorMessage("");
    // console.log("LOGIN_PATHS.LOGIN_DETAILS ", LOGIN_PATHS.LOGIN_DETAILS);
    // prefixChild is /currentSource/step/child
    switch (prefixChild) {
      case LOGIN_PATHS.LOGIN_DETAILS:
        loginRequest(data);

        break;
      case LOGIN_PATHS.LOGIN_OTP:
        setOperationModel(2);
        const otpData = {
          feCustOTP: data.otp,
          feCustPersId: fXEligibilityData?.personalId,
          feOperationModel: 2,
          feBU: businessUnit,
        };
        setShowButtonLoader(true);
        dispatch(checkOrCreateOtp(otpData));

        break;

      case LOGIN_PATHS.CHOOSE_POLICY:
        const { id, phone, otp } = methods.getValues();
        const submitedData = { id, phone, otp, isChecked, selectedPolicyItem };

        const fePolicyDetails: PolicyDetailsUpdate = {
          feLeadNote: selectedPolicy.leadDetailsDtoField.leadNoteField || "",
          fePolicyEndDate: selectedPolicy.policyDtoField.policyEndDateField,
          fePolicyDestinationISO:
            selectedPolicy.countryOfDestinationDtoField.map(
              (country) => country.countryISOField
            ),
          fePolicyPurchaseDate:
            selectedPolicy.policyDtoField.policyPurchaseDateField,
          feAgentName: selectedPolicy.leadDetailsDtoField.agentNameField,
          feCreatedBy: selectedPolicy.policyDtoField.createdByField,
          fePolicyId:
            selectedPolicy.policyDtoField.travelPolicyNumberField.toString(),
          fePolicyDestination: selectedPolicy.countryOfDestinationDtoField.map(
            (country) => country.countryField
          ),
          fePolicyStartDate: selectedPolicy.policyDtoField.policyStartDateField,
          fePolicyNumOfPassangers:
            selectedPolicy.leadDetailsDtoField.numberOfPassangersField,
          fePolicyAgentId:
            agentId ??
            selectedPolicy.leadDetailsDtoField.agentIDField.toString(),
          feCollectCardInstructions:
            fXEligibilityData?.collectCardInstruction,
          feSaleRepresentetiveId:
            selectedPolicy.policyDtoField.saleRepresentetiveIdField,
          feSaleRepresentetiveName:
            selectedPolicy.policyDtoField.saleRepresentativeNameField,
        };

        const policyData: UpdatePolicyRequest = {
          feVIPTypeID: "",
          feIsMarkedAsTesting: false,
          fePolicyDetails,
          feCustPersId: fXEligibilityData?.personalId,
          feVIPCode: "",
          feSendAdsByEmailBy3rdParty: false,
          feBU: businessUnit,
        };
        setShowButtonLoader(true);
        dispatch(updatePolicy(policyData));

        break;
      default:
        __DEV__ && console.log("Hi 3 ", prefixChild);
        navigate(`/${hostUrl}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
        break;
    }
  };
  useEffect(() => {
    if (updatePolicyResStatus === API_RESULT.SUCCEEDED) {
      setShowButtonLoader(false);
      if (updatePolicyRes.responseCode == "0") {
        navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
      } else {
        setErrorMessage({
          text: strings.t_login_error,
          ariaLabel: strings.t_login_error,
        });
      }
    }
  }, [updatePolicyResStatus]);

  useEffect(() => {
    // came from OTP result now we need to move to pc-pay screen
    if (checkOrCreateOtpResStatus === API_RESULT.SUCCEEDED) {
      setShowButtonLoader(false);
      setSendAgainLoading(false);

      if (checkOrCreateOtpRes) {
        if (operationModel == 2) {
          // if (pcPlusRoutes.includes(currentSource as URL_SOURCE_TYPE)) {
          //   navigate(`/${currentSource}/${ROUTES.LOGIN_CHOOSE_POLICY}`);
          // } else {
          //   navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
          // }
          // check if there is more than one policy so navigate to choose policy
          if (fXEligibilityData.policyDetails.length > 1) {
            navigate(
              `/${currentSource}/${ROUTES.LOGIN}/${ROUTES.LOGIN_CHOOSE_POLICY}`
            );
          } else {
            dispatch(setTravelPolicyNumber(fXEligibilityData.policyDetails[0].policyDtoField.travelPolicyNumberField.toString()));
            navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
          }
        }
        // navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);

        dispatch(resetCheckOrCreateOtpResStatus());
      } else {
        setShowButtonLoader(false);
        //  dispatch(setOtpErrorMessage(strings.t_login_error));
        setErrorMessage({
          text: strings.t_login_error,
          ariaLabel: strings.t_login_error,
        });
        dispatch(resetCheckOrCreateOtpResStatus());
      }
    } else if (checkOrCreateOtpResStatus === API_RESULT.LOADING) {
      setSendAgainLoading(true);
    } else if (checkOrCreateOtpResStatus === API_RESULT.FAILED) {
      setSendAgainLoading(false);
      setShowButtonLoader(false);

      const responseCode = checkOrCreateOtpErrorRes?.data?.responseCode;

      switch (responseCode) {
        case 1:
          setErrorMessage({
            text: strings.t_otp_invalid_code,
            ariaLabel: strings.t_otp_invalid_code,
          });
          break;
        case 2:
          setErrorMessage({
            text: strings.t_otp_expired_code,
            ariaLabel: strings.t_otp_expired_code,
          });
          break;
        case 3:
          setErrorMessage({
            text: strings.t_otp_blocked_user,
            ariaLabel: strings.t_otp_blocked_user,
          });
          break;
        default:
          break;
      }
      dispatch(resetCheckOrCreateOtpResStatus());
      //clear the otp field
      methods.setValue("otp", "");
    }
  }, [checkOrCreateOtpResStatus]);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };
  const handleCheckboxChangePolicy = (event: ChangeEvent<HTMLInputElement>) => {
    setIsCheckedPolicy(event.target.checked);
  };
  useEffect(() => {
    const { id, phone, otp } = methods.getValues();
    switch (location.pathname) {
      case LOGIN_PATHS.LOGIN_DETAILS:
        setButtonDisabled(
          id.trim().length !== INPUT_LENGTH.ID ||
          phone.trim().length !== INPUT_LENGTH.PHONE
        );
        break;
      case LOGIN_PATHS.LOGIN_OTP:
        setButtonDisabled(otp.trim().length !== INPUT_LENGTH.OTP);
        break;
      case LOGIN_PATHS.CHOOSE_POLICY:
        setButtonDisabled(!isCheckedPolicy);
        break;
      default:
        break;
    }
  }, [methods.watch(), isChecked, isCheckedPolicy]);

  const getByTitle = (): Title | string => {
    switch (location.pathname) {
      case `${LOGIN_PATHS.LOGIN_OTP}`:
      case `${LOGIN_PATHS.LOGIN_DETAILS}`:
        return {
          text: strings.t_login_title,
          ariaLabel: strings.acc_t_login_title,
        };

      case `${LOGIN_STEP.CHOOSE_POLICY}`:
        return {
          text: strings.t_choose_policy_title,
          ariaLabel: strings.acc_t_choose_policy_title,
        };
      default:
        return "";
    }
  };
  const sendAgain = () => {
    setSendAgainDisabled(true);
    __DEV__ && console.log("sendAgain ", sendAgainClicked);
    setTimeout(() => setSendAgainDisabled(false), COOLDOWN_PERIOD);
    if (!sendAgainClicked) {
      setSendAgainClicked(true);
      setOperationModel(1);
      const otpData = {
        feCustOTP: "",
        feCustPersId: fXEligibilityData?.personalId,
        feOperationModel: 1,
        feBU: businessUnit,
      };
      dispatch(checkOrCreateOtp(otpData));
    } else {
      setSendAgainClicked(false);
    }
  };
  return (
    <FormProvider {...methods}>
      <div className={styles.container}>
        <MainImageBackground
          desktopImageSrc={images.mainImage}
          mobileImageSrc={images.mainMobile}
        />
        <UICard>
          <>
            <label id="aria-label-text" htmlFor="link-back" className="srOnly">
              {strings.acc_t_back}
            </label>
            {location.pathname !== LOGIN_PATHS.LOGIN_DETAILS && (
              <a
                id="link-back"
                href={
                  // check if currentPath is /ensure/login/details
                  // currentPath === "/sms/login/otp"
                  currentPath === `/${currentSource}${LOGIN_STEP.OTP}`
                    ? `/${currentSource}${LOGIN_STEP.LOGIN}`
                    : `/${currentSource}/${ROUTES.PC_PLUS_SCREEN}`
                }
                className={styles.backButton}
                aria-describedby={"aria-label-text"}
              >
                <UIText
                  text={strings.t_back}
                  size={18}
                  weight={400}
                  style={styles.link}
                />
              </a>
            )}
            <ScreenReaderText
              text={(getByTitle() as Title).ariaLabel}
              announnceDelay={2100}
            />

            <UIText
              text={(getByTitle() as Title).text}
              ariaLabel={(getByTitle() as Title).ariaLabel}
              tag={TEXT_TAGS.H1}
              size={24}
              weight={500}
              style={styles.cardTitle}
            />

            <Separator className={styles.separator} />

            <Outlet
              context={{
                phone: methods.getValues().phone,
                isChecked,
                handleCheckboxChange,
                checkboxChange: handleCheckboxChangePolicy,
                setChoosenPolicyItem: setSelectedPolicyItem,
              }}
            />
            {location.pathname === LOGIN_PATHS.FULL_LOGIN_OTP &&
              otpErrorMessage.length === 0 && (
                <div className={styles.sendAgainWrapper}>
                  <UIButton
                    title={strings.t_send_again}
                    onSubmit={() => sendAgain()}
                    style={styles.sendAgainButton}
                    disabled={sendAgainDisabled}
                    isLoading={sendAgainLoading && sendAgainClicked}
                  />
                </div>
              )}
            {!!errorMessage && (
              <div className={styles.loginErrorMessageWrapper}>
                <br />
                <ErrorMessage
                  style={styles.error}
                  message={(errorMessage as ErrorText).text}
                  ariaLabel={(errorMessage as ErrorText).ariaLabel}
                />
                <br />
              </div>
            )}
            <div className={styles.buttonWrapepr}>
              <UIButton
                title={strings.t_active_credit_next}
                ariaLabel={
                  buttonDisabled
                    ? strings.acc_t_active_credit_next_disabled
                    : ""
                }
                onSubmit={methods.handleSubmit(onSubmit)}
                disabled={buttonDisabled || showButtonLoader}
                isLoading={showButtonLoader}
              />
            </div>
          </>
        </UICard>
      </div>
    </FormProvider>
  );
};

export default LoginScreen;
